export { SOCIAL_TEST_IDS, SOCIAL_ACCESSIBILITY_LABEL } from "./social";
export { TEST_IDS, ACCESSIBILITY_LABEL } from "./common";
